<template>
  <div class="main" :style="{'minHeight': mainHeight}">
<!--    :style="{'height': window.innerHeight - 102 - 48 + 'px'}">-->

    <div class="blocks f-b-c">
      <div class="block" v-for="(item, index) in blocks" :key="index">
        <div class="f-c-c fc blockContent">
          <div class="f-c-c customLogo">
            <el-image :src="item.img" style="width: 65%;height: 65%;" fit="contain" />
          </div>
          <div style="height: 50px"></div>
          <div>
            <div class="blockBtn" @click="$router.push(item.btn.toLowerCase())">{{item.btn}}</div>
          </div>
        </div>
      </div>

    </div>

    <div class="f-c-c fc loginBlock" v-if="!$cookie.get('sw_username')">

      <el-form :model="formData" :rules="rules" ref="loginForm" class="f-b-c info">
        <div class="fc" style="width: 45%">
          <div class="f-c-c">
            <span style="margin-top: -22px;color: #492500;font-size: 15px">Email:</span>
            <el-form-item class="f-c-c" prop="username">
              <el-input class="customInp" v-model="formData.username"></el-input>
            </el-form-item>
          </div>
          <div style="font-size: 13px">
            <el-checkbox v-model="re">remember my email address</el-checkbox>
          </div>
        </div>
        <div class="fc" style="width: 45%;">
          <div class="f-c-c">
            <span style="margin-top: -22px;color: #492500;font-size: 15px">Password:</span>
            <el-form-item class="f-c-c" prop="password">
              <el-input type="password" class="customInp" v-model="formData.password" @keydown.native.13="login"></el-input>
            </el-form-item>
          </div>
          <div style="font-size: 13px">
            <u @click="lostPassword">lost password?</u>
          </div>
        </div>
      </el-form>

      <div class="f-c-c" style="margin-top: 10px;width: 50%; min-width: 960px">
        <div class="blockBtn gray" @click="login">Sign in</div>
        <div class="blockBtn gray" @click="register">Register</div>
      </div>

    </div>

  </div>
</template>

<script>

export default {
  name: 'home',
  data () {
    return {
      mainHeight: 0,
      username: '',
      blocks: [
        {
          img: require('../../static/img/icon-shine.png'),
          btn: 'Shine'
        },
        {
          img: require('../../static/img/icon-clock.png'),
          btn: 'Epi-clock'
        },
        {
          img: require('../../static/img/icon-wind.png'),
          btn: 'Wind'
        }
      ],
      re: false,
      formData: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: 'Please enter email', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid email', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please enter password', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    const re = localStorage.getItem('userEmail_sw')
    if (re) {
      this.$set(this.formData, 'username', re)
      this.$set(this.$data, 're', true)
    }

    this.$nextTick(() => this.setWindowHeight())
  },
  methods: {
    setWindowHeight () {
      var wheight = (window.innerHeight) ? window.innerHeight : (document.documentElement && document.documentElement.clientHeight) ? document.documentElement.clientHeight : document.body.offsetHeight

      var scrollHeight = (document.documentElement) ? document.documentElement.scrollTop : document.body.scrollTop

      this.$set(this.$data, 'mainHeight', wheight + scrollHeight - 102 - 48 + 'px')

      window.addEventListener('resize', function () {
        var wheight = (window.innerHeight) ? window.innerHeight : (document.documentElement && document.documentElement.clientHeight) ? document.documentElement.clientHeight : document.body.offsetHeight

        var scrollHeight = (document.documentElement) ? document.documentElement.scrollTop : document.body.scrollTop

        this.$set(this.$data, 'mainHeight', wheight + scrollHeight - 102 - 48 + 'px')
      }.bind(this))
    },
    login () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          if (this.re) { // 记住邮箱
            localStorage.setItem('userEmail_sw', this.formData.username)
          } else {
            localStorage.removeItem('userEmail_sw')
          }
          // login
          this.$http({
            url: this.$http.adornUrl('/sys/login'),
            method: 'post',
            data: this.$http.adornData({
              ...this.formData,
              'uuid': '10086',
              'captcha': '10010'
            })
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message.success('Login successful')
              this.$cookie.set('sw_token', data.token)
              this.getUserInfo()
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    getUserInfo () {
      this.$http({
        url: this.$http.adornUrl('/sys/user/info'),
        method: 'get'
      }).then(({data}) => {
        console.log(data)
        if (data && data.code === 0) {
          this.$cookie.set('sw_username', data.user.username)
          this.$router.go(0)
        }
      })
    },
    register () {
      this.$router.push({path: '/register'})
    },
    lostPassword () {
      this.$router.push({path: '/lostPassword'})
    }
  }
}
</script>

<style scoped>
  .main {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("../../static/img/background.png") no-repeat;
    background-size: 100% 100%;
    /*justify-content: center;*/
  }
  .blocks {
    padding: 35px 0;
    width: 50%;
    min-width: 960px
  }
  .block {
    opacity: 0.75;
    transition: all 0.2s;
    background: #B4C052;
    width: 32%;
    height: 420px;
    min-height: 420px;
    min-width: 280px
  }
  .block:hover{
    transform: scale(1.2, 1.15)
  }
  .blockContent {
    opacity: 0.9;
    background: #DCE395;margin: 10px 0 20px 0;
    height: calc(100% - 30px);width: 100%
  }
  .blockBtn {
    transition: all 0.1s;cursor: pointer;
    color: white;background: #b1be54;font-size: 16px;
    padding: 8px 35px;border: 1px solid white;
    border-radius: 20px;box-shadow: 0 8px 5px #728108;
    margin: 0 20px;
  }
  .loginBlock .blockBtn:hover{
    transform: scale(1.1)
  }
  .info {
    background: #D1D990;opacity: 0.9;width: 80%;padding: 20px 35px
  }

  * /deep/ .customInp input {
    background: #939D31;margin: 0 15px;color:white;
    border: 2px solid white;font-size: 13px;
    height: 32px;line-height:32px; border-radius: 15px;
  }

  * /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #9CA63E;
    border-color: #9CA63E
  }

  * /deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #9CA63E
  }

  * /deep/ .el-checkbox__inner:hover {border-color: #9CA63E}

  * /deep/ .el-checkbox__inner.is-focus {border-color: #9CA63E}

  .gray {
    color: #383300
  }

  .loginBlock {
    width: 50%;min-width: 960px;height: 200px;background: #C8D279; opacity: 0.9;
  }

  .customLogo {
    border: 5px solid #6C780D;
    font-size: 46px;color: #6e7b07;
    border-radius: 50%;
    width: 128px;height: 128px;
    background: #DEE691
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue